<template>
    <div class="app__page-wrapper | u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <wizard-steps :step="3" />

                <div class="product | u-wizard-padding-bottom">
                    <div class="product__title">
                        <h2>{{ trans('order.choose-ssl') }}</h2>
                    </div>
                    <ssl-partial
                        v-if="domains"
                        v-for="(domain, index) in domains"
                        :key="domain.domain"
                        :domain="domain"
                        :index="index"
                    />
                </div>
            </div>
        </div>

        <wizard-footer>
            <div class="u-flex-between">
                <customer-router-link :to="{ name: 'orderFullHosting' }">
                    <div class="button-back-wrapper">
                        <button type="button" class="btn btn--back">
                            {{ trans('order.navigation.hosting') }}
                        </button>
                    </div>
                </customer-router-link>
                <customer-router-link :to="{ name: 'orderFullOverview' }">
                    <div class="button-nav-submit">
                        <button type="button" dusk="step3-submit-button" class="btn btn--ghost btn--submit btn--nav">
                            {{ trans('order.navigation.overview') }}
                        </button>
                    </div>
                </customer-router-link>
            </div>
        </wizard-footer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { pageLoadingStatusMixin } from 'relapp-loading';

import WizardSteps from '@/components/WizardSteps.vue';
import WizardFooter from '@/components/WizardFooter.vue';
import { SslPartial, supportMixin, orderPageMixin } from 'relapp-register';

export default {
    components: {
        WizardSteps,
        WizardFooter,
        SslPartial
    },
    mixins: [pageLoadingStatusMixin, supportMixin, orderPageMixin],
    computed: {
        ...mapGetters({
            domains: 'order/domains'
        })
    },
    metaInfo: {
        title: trans('page.order.ssl')
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.finishLoading();
    }
};
</script>
